import React from "react"
import Navbar from "../../../../Common/Navbar"
import Footer from "../../../../Common/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import TsTaskViewComp from "./Component/TsTaskViewComp"


const TsTaskView =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TsTaskViewComp />
        </div>
        <Footer />
        </>
    )
}

export default TsTaskView